import api from "./api"; // Import the new axios instance
import { products } from "../config/products";

const packageJson = require("../../package.json");

export const invokeApi = async (url, params, cookies) => {
    const cleanUrl = url ? url.trim() : "";
    if (cleanUrl.includes("/getAllProducts") || cleanUrl.includes("/all")) {
        return {
            status: 200,
            data: {
                responseCode: '200',
                responseMessage: "Success",
                products: products
            }
        };
    }
    if (cleanUrl.includes("/featured")) {
        return {
            status: 200,
            data: products.slice(0, 4)
        };
    }
    const matchingProduct = products.find(p => p.slug === cleanUrl.replace(/^\//, "") || p.ogUrl === cleanUrl.replace(/^\//, ""));
    if (matchingProduct) {
        return {
            status: 200,
            data: matchingProduct
        };
    }

    try {
        // 'cookies' argument is now optional/ignored as the interceptor handles it
        // We use the 'api' instance which has the base URL and interceptors configured
        return await api.post(url, params);
    } catch (error) {
        // Return the error response to maintain backward compatibility with components checks
        return error.response || { status: 500, data: { responseMessage: "Network Error" } };
    }
};

export const invokePostApi = invokeApi;

export const invokePutApi = async (url, params) => {
    try {
        return await api.put(url, params);
    } catch (error) {
        return error.response || { status: 500, data: { responseMessage: "Network Error" } };
    }
};

export const invokeGetApi = async (url, params) => {
    const cleanUrl = url ? url.trim() : "";
    if (cleanUrl.includes("/getAllProducts") || cleanUrl.includes("/all")) {
        return {
            status: 200,
            data: {
                responseCode: '200',
                responseMessage: "Success",
                products: products
            }
        };
    }
    if (cleanUrl.includes("/featured")) {
        return {
            status: 200,
            data: products.slice(0, 4)
        };
    }
    const matchingProduct = products.find(p => p.slug === cleanUrl.replace(/^\//, "") || p.ogUrl === cleanUrl.replace(/^\//, ""));
    if (matchingProduct) {
        return {
            status: 200,
            data: matchingProduct
        };
    }

    try {
        return await api.get(url, { params: params });
    } catch (error) {
        return error.response || { status: 500, data: { responseMessage: "Network Error" } };
    }
};

export const invokeFormDataApi = async (url, formData, cookies) => {
    try {
        return await api.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    } catch (error) {
        return error.response || { status: 500, data: { responseMessage: "Network Error" } };
    }
};

// Use this for UPDATE (edit) calls that include file uploads — backend expects PUT
export const invokeFormDataPutApi = async (url, formData) => {
    try {
        return await api.put(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    } catch (error) {
        return error.response || { status: 500, data: { responseMessage: "Network Error" } };
    }
};

export const invokeDeleteApi = async (url, params) => {
    try {
        return await api.delete(url, { data: params });
    } catch (error) {
        return error.response || { status: 500, data: { responseMessage: "Network Error" } };
    }
};

export const apiList = {
  // Authentication & Users
  signup: "/signup",
  login: "/login",
  userLogin: "/login",
  addUser: "/addUser",
  getUsers: "/getUsers",
  getUser: "/getUser",
  updateUser: "/updateUser",
  changePassword: "/changePassword",
  deleteUser: "/deleteUser",
  updateUserRoles: "/updateUserRoles",

  // Products
  featured: "/featured",
  allProducts: "/all",
  getAllProducts: "/getAllProducts",
  addProduct: "/addProduct",
  updateProduct: "/updateProduct", // POST /updateProduct/{id}
  deleteProduct: "/deleteProduct", // POST /deleteProduct/{id}
  updateProductGallery: "/updateProductGallery",
  getAllCategory: "/getAllCategory",
  addCategory: "/addCategory",
  getCategory: "/getCategory",
  updateCategory: "/updateCategory",
  deleteCategory: "/deleteCategory",
  addSubCategory: "/addSubCategory",
  getAllSubCategory: "/getAllSubCategory",
  getSubCategory: "/getSubCategory",
  updateSubCategory: "/updateSubCategory",
  deleteSubCategory: "/deleteSubCategory",
  getProductByOgUrl: "/getProductByOgUrl",

  // Orders & Cashfree Payments
  getAllProductOrder: "/getAllProductOrder",
  getAllOrderTrack: "/getAllOrderTrack",
  addProductOrder: "/addProductOrder",
  updateOrderStatus: "/updateOrderStatus",
  deleteOrder: "/deleteOrder",
  getOrderByPhone: "/getOrderByPhone",
  generateOrder: "/generateOrder",
  getOrders: "/getOrders",
  createCashfreeOrder: "/createCashfreeOrder",
  verifyCashfreePayment: "/verifyCashfreePayment",
  getCashfreeConfig: "/getCashfreeConfig",

  // Addresses
  getAllAddress: "/getAllAddress",
  addAddress: "/addAddress",
  deleteAddress: "/deleteAddress",

  // Leads
  addLead: "/addLead",
  addARGLead: "/addARGLead",
  getLeads: "/getLeads",
  updateLead: "/updateLead",

  // Blog
  addBlog: "/addBlog",
  getBlogs: "/getBlogs",
  updateBlog: "/updateBlog",
  getBlog: "/getBlog",
  approveBlog: "/approveBlog",
  deleteBlog: "/deleteBlog",
  addBlogBanner: "/addBlogBanner",
  addBlogFeaturedImage: "/addBlogFeaturedImage",
  getArticles: "/getArticles",
  getArticleByOgUrl: "/getArticleByOgUrl",

  // SEO Management
  addSite: "/addSite",
  getAllSites: "/getAllSites",
  getSite: "/getSite",
  updateSite: "/updateSite",
  addMetaData: "/addMetaData",
  getMetaDataBySite: "/getMetaDataBySite",
  updateMetaData: "/updateMetaData",
  updateSeoFaqs: "/updateSeoFaqs",

  // Location Pages
  addNewPage: "/addNewPage",
  getPage: "/getPage",
  getLocationData: "/getLocationData",
  getPages: "/getPages",
  getPageByID: "/getPageByID",
  addLocation: "/addLocation",
  getLocations: "/getLocations",
  addBannerImage: "/addBannerImage",
  addGallery: "/addGallery",
  addFeaturedImage: "/addFeaturedImage",

  // Admin Specific
  adminProducts: "/admin/products",
  adminSaveProduct: "/admin/save-product",
  adminDeleteProduct: "/admin/product",

  // Sections (Developer Tooling)
  addSection: "/addSection",
  getSections: "/getSections",

  // Dashboard Stats
  getDashboardStats: "/getDashboardStats",

  // Invoice Management
  createInvoice:       "/invoice/create",
  getInvoices:         "/getInvoices",
  getInvoice:          "/getInvoice",
  updateInvoice:       "/invoice/update",
  updateInvoiceStatus: "/invoice/update-status",
  deleteInvoice:       "/invoice/delete",
  getInvoiceStats:     "/invoice/stats",
  invoicePublicView:   "/invoice/view",   // GET /invoice/view/{token}

  // Track Order Alias
  trackOrder: "/track-order",
};
